import PolyIcon, { PolyPlusBadge } from "elements/PolyIcon";
import React from "react";
import { generatePath, Link } from "react-router-dom";
import { useTranslation } from "utilities/i18n";

export const ConfigureNotifications: React.FC<{ tenantId: string }> = ({
  tenantId
}) => {
  const { t } = useTranslation();
  const notificationCenterUrl = generatePath(
    "/admin/accounts/details/:tenantId/notifications/email?tenantId=:tenantId",
    { tenantId: tenantId }
  );
  return (
    <div className=" mt-35 card small-radius poly-plus-shadow">
      <div className="pt-15 pl-15">
        <PolyPlusBadge className="small" />
      </div>
      <div className="pl-15 pt-1 font-sm font-bold">
        {t("SET_CUSTOM_NOTIFICATIONS")}
      </div>
      <div className="pl-15 pb-15 pt-5 font-sm font-bold link">
        <Link to={notificationCenterUrl}>
          <PolyIcon
            icon="overview_settings"
            title="Configure icon"
            className="link sm pr-5 align-top"
          />
          {t("CONFIGURE")}
        </Link>
      </div>
    </div>
  );
};

export default ConfigureNotifications;
